import type { HandlingStatus, InboxFeedItem, InboxViewFilter } from '../types/inbox'
import { isEntityUnlinked } from './inboxPermissions'

export function isStaffUnassigned(item: Pick<InboxFeedItem, 'assignedToUserId' | 'handlingStatus'>): boolean {
  return !item.assignedToUserId && item.handlingStatus === 'open'
}

export function matchesInboxViewFilter(
  item: InboxFeedItem,
  filter: InboxViewFilter,
  currentUserId: string | null,
  assigneeFilterId?: string | null,
  queueId?: string | null
): boolean {
  switch (filter) {
    case 'all_open':
      return item.handlingStatus !== 'resolved' && item.state === 'active'
    case 'my_items':
      return (
        !!currentUserId &&
        item.assignedToUserId === currentUserId &&
        item.handlingStatus !== 'resolved' &&
        item.state === 'active'
      )
    case 'staff_unassigned':
      return isStaffUnassigned(item) && item.state === 'active'
    case 'unlinked':
      return isEntityUnlinked(item) && item.state === 'active'
    case 'by_assignee':
      if (!assigneeFilterId) return true
      return item.assignedToUserId === assigneeFilterId
    case 'waiting':
      return item.handlingStatus === 'waiting' && item.state === 'active'
    case 'resolved':
      return item.handlingStatus === 'resolved'
    case 'by_queue':
      if (!queueId) return true
      return item.queueId === queueId
    default:
      return true
  }
}

export function handlingStatusLabel(status: HandlingStatus): string {
  switch (status) {
    case 'open':
      return 'Open'
    case 'assigned':
      return 'Assigned'
    case 'waiting':
      return 'Waiting'
    case 'resolved':
      return 'Resolved'
    default:
      return status
  }
}

export function handlingStatusBadgeClass(status: HandlingStatus): string {
  switch (status) {
    case 'open':
      return 'bg-sky-50 text-sky-700'
    case 'assigned':
      return 'bg-blue-50 text-blue-700'
    case 'waiting':
      return 'bg-amber-50 text-amber-700'
    case 'resolved':
      return 'bg-green-50 text-green-700'
    default:
      return 'bg-gray-100 text-gray-600'
  }
}

export const INBOX_VIEW_FILTERS: Array<{ value: InboxViewFilter; label: string }> = [
  { value: 'all_open', label: 'All open' },
  { value: 'my_items', label: 'My items' },
  { value: 'staff_unassigned', label: 'Unassigned (staff)' },
  { value: 'unlinked', label: 'Unlinked' },
  { value: 'waiting', label: 'Waiting' },
  { value: 'resolved', label: 'Resolved' },
  { value: 'by_assignee', label: 'By assignee' },
  { value: 'by_queue', label: 'By queue' },
]

export const HANDLING_STATUS_OPTIONS: HandlingStatus[] = ['open', 'assigned', 'waiting', 'resolved']

export const TASK_QUICK_PRESETS = [
  { action_type: 'call_back', title: 'Call back' },
  { action_type: 'send_quote', title: 'Send quote' },
  { action_type: 'confirm_schedule', title: 'Confirm schedule' },
  { action_type: 'follow_up', title: 'Follow up' },
] as const
